import { render } from "./RoundReviewCard.vue?vue&type=template&id=d14dea28&scoped=true"
import script from "./RoundReviewCard.vue?vue&type=script&lang=js"
export * from "./RoundReviewCard.vue?vue&type=script&lang=js"

import "./RoundReviewCard.vue?vue&type=style&index=0&id=d14dea28&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d14dea28"]])

export default __exports__